import React from "react";
import student from "../images/student.png";
import company from "../images/company.png";

function Information() {
  return (
    <div>
      <h1 id="content_header">About</h1>
      <div className="information">
        <div className="info">
        Akarsh is a BS-MCS Computer Science student at the University of Illinois at Urbana-Champaign currently interning for Capital One as a Software Engineering Intern. He has experience programming in Python, C/C++, and Java through internships and academia.
        </div>
      </div>
    </div>
  );
}

export default Information;
